import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import caComu from '@/locales/ca/comu.json';
import caOperacio from '@/locales/ca/operacio.json';
import caPlanificacio from '@/locales/ca/planificacio.json';
import caInformes from '@/locales/ca/informes.json';
import caAdministracio from '@/locales/ca/administracio.json';
import caErrors from '@/locales/ca/errors.json';
import esComu from '@/locales/es/comu.json';
import esOperacio from '@/locales/es/operacio.json';
import esPlanificacio from '@/locales/es/planificacio.json';
import esInformes from '@/locales/es/informes.json';
import esAdministracio from '@/locales/es/administracio.json';
import esErrors from '@/locales/es/errors.json';
// Parts d'Ajustos: cada fitxer és una branca de l'espai 'administracio' (t('estructura.…'), etc.).
import caAjMarc from '@/locales/ca/ajustos/marc.json';
import caAjEstructura from '@/locales/ca/ajustos/estructura.json';
import caAjPersones from '@/locales/ca/ajustos/persones.json';
import caAjAvisos from '@/locales/ca/ajustos/avisos.json';
import caAjSistema from '@/locales/ca/ajustos/sistema.json';
import esAjMarc from '@/locales/es/ajustos/marc.json';
import esAjEstructura from '@/locales/es/ajustos/estructura.json';
import esAjPersones from '@/locales/es/ajustos/persones.json';
import esAjAvisos from '@/locales/es/ajustos/avisos.json';
import esAjSistema from '@/locales/es/ajustos/sistema.json';

export const IDIOMES = ['ca', 'es'] as const;
export type Idioma = (typeof IDIOMES)[number];
export const IDIOMA_PER_DEFECTE: Idioma = 'ca';
export const NAMESPACES = [
  'comu',
  'operacio',
  'planificacio',
  'informes',
  'administracio',
  'errors',
] as const;
export type Namespace = (typeof NAMESPACES)[number];

const CLAU_IDIOMA = 'cai.idioma';

export const resources = {
  ca: {
    comu: caComu,
    operacio: caOperacio,
    planificacio: caPlanificacio,
    informes: caInformes,
    administracio: {
      ...caAdministracio,
      marc: caAjMarc,
      estructura: caAjEstructura,
      persones: caAjPersones,
      avisos: caAjAvisos,
      sistema: caAjSistema,
    },
    errors: caErrors,
  },
  es: {
    comu: esComu,
    operacio: esOperacio,
    planificacio: esPlanificacio,
    informes: esInformes,
    administracio: {
      ...esAdministracio,
      marc: esAjMarc,
      estructura: esAjEstructura,
      persones: esAjPersones,
      avisos: esAjAvisos,
      sistema: esAjSistema,
    },
    errors: esErrors,
  },
} as const;

export function esIdioma(valor: unknown): valor is Idioma {
  return typeof valor === 'string' && (IDIOMES as readonly string[]).includes(valor);
}

export function idiomaDesat(): Idioma {
  try {
    const v = localStorage.getItem(CLAU_IDIOMA);
    return esIdioma(v) ? v : IDIOMA_PER_DEFECTE;
  } catch {
    return IDIOMA_PER_DEFECTE;
  }
}

export function idiomaActual(): Idioma {
  return esIdioma(i18n.resolvedLanguage) ? i18n.resolvedLanguage : IDIOMA_PER_DEFECTE;
}

export async function canviaIdioma(idioma: Idioma): Promise<void> {
  try {
    localStorage.setItem(CLAU_IDIOMA, idioma);
  } catch {
    /* empty */
  }
  if (typeof document !== 'undefined') document.documentElement.lang = idioma;
  if (i18n.language !== idioma) await i18n.changeLanguage(idioma);
}

void i18n.use(initReactI18next).init({
  resources,
  lng: idiomaDesat(),
  fallbackLng: IDIOMA_PER_DEFECTE,
  supportedLngs: [...IDIOMES],
  ns: [...NAMESPACES],
  defaultNS: 'comu',
  interpolation: { escapeValue: false },
  returnNull: false,
});

if (typeof document !== 'undefined') document.documentElement.lang = idiomaActual();

export default i18n;
